export const ENABLE_NEW_THUMBNAIL_SKINS_FO_FILE_SHARE_PANELS =
  'enableNewThumbnailSkinsFoFileSharePanels';
